export { default } from './MedicationsModule';
